import type { ElementType } from "react"
import { twMerge } from "tailwind-merge"

interface SkeletonProps extends React.ComponentProps<"div"> {
  soft?: boolean
  /**
   * Element to render. Use `"span"` when the skeleton sits inside phrasing-only
   * content such as a `<button>` or `<p>`, where a nested `<div>` is invalid.
   */
  as?: "div" | "span"
}

const Skeleton = ({ ref, soft = false, as = "div", className, ...props }: SkeletonProps) => {
  // Widened so JSX resolves a single call signature for the "div" | "span" union.
  const Tag = as as ElementType

  return (
    <Tag
      data-slot="skeleton"
      ref={ref}
      className={twMerge(
        "shrink-0 rounded-sxs relative overflow-hidden",
        as === "span" && "block",
        soft ? "bg-muted/40" : "bg-muted",
        "before:absolute before:inset-0",
        "before:bg-linear-to-r before:from-transparent before:via-white/55 before:to-transparent",
        "before:animate-shimmer-slide before:[animation-delay:var(--shimmer-delay,0s)]",
        className,
      )}
      {...props}
    />
  )
}

export type { SkeletonProps }
export { Skeleton }
